import { useState, useEffect } from 'react';
import { logger } from '../utils/logger';

/**
 * @file A custom hook to track the browser's online status.
 */

/**
 * Hook to track browser's online status.
 * @returns {boolean} True if the browser is online, false otherwise.
 */
const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      logger.log('Online status: now online');
      setIsOnline(true);
    };

    const handleOffline = () => {
      logger.log('Online status: now offline');
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
};

export default useOnlineStatus;
